export default __webpack_public_path__ + "static/media/shopping-cart.e2ee59b1.svg";